import api from "./api"

// gets user token
export function getUserToken ()
{
    const user_token = localStorage.getItem('user_token')
    if (user_token)
    {
        return user_token
    } else
    {
        return "Token not established"
    }
}

// gets user name
export function getUserName ()
{
    const user_name = localStorage.getItem('user_name')

    if (user_name)
    {
        return user_name
    } else
    {
        return "Name not established"
    }
}

// store user data: name, email, and token
export function storeUserCredentials (user, token)
{
    if (user)
    {
        localStorage.setItem('user_name', user.name)
        localStorage.setItem('user_email', user.email)
    }
    if (token)
        localStorage.setItem('user_token', token)
    
    return true
}

export function destroyUserCredentials ()
{
    localStorage.removeItem('user_token')
    localStorage.removeItem('user_name')
    localStorage.removeItem('user_email')

    return true
}

// returns user role by accessing the database for added security
export async function getuserRole ()
{
    try {
        const response = await api.get('/user/role')
        if (response.data.status == 'success')
        {
            return response.data.role
        }

        return ''
    } catch (error)
    {
        return ''
    }
}